import { BackLink } from './back-link'
import { useStyles } from './floating-back-link.style'

export const FloatingBackLink = function (props) {
  const classes = useStyles()
  return (
    <div className={classes.backLink}>
      <BackLink {...props} />
    </div>
  )
}
